import './style.scss';
import React from 'react';
import OfferCardGridItemComponent from '../OfferCardGridItemComponent';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
const OfferList = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="OfferList" />;
  }
  const { offers: cards } = props?.fields;
  const { t, i18n, params } = props;
  const lang = i18n.language;

  const shouldRenderCards = !!cards;
  //remove expired, same logic done in offers helpers

  return (
    <div className={clsx('offer-card-grid-items flex-it flex-wrap', 'add-margins', params?.Styles)}>
      {shouldRenderCards &&
        cards?.map((card, iCard) => {
          if (
            card?.fields?.validitystart > new Date().toISOString() ||
            (card?.fields?.validityEnd < new Date().toISOString() &&
              !card?.fields?.validityEnd?.value?.startsWith('0001'))
          ) {
            return null;
          }

          return <OfferCardGridItemComponent item={card} key={iCard} lang={lang} translate={t} />;
        })}
    </div>
  );
};

export default withTranslation()(OfferList);
